const userAgentTestRegExp = /MarktplaatsWebiew/;

export default function isMobileApp(userAgent: string = window.navigator.userAgent): boolean {
  return userAgent ? userAgentTestRegExp.test(userAgent) : false;
}
